// extracted by mini-css-extract-plugin
export var hamburgerMenuButton = "SlideInMenu-module--hamburgerMenuButton--11Yq1";
export var wrapper = "SlideInMenu-module--wrapper--30FH_";
export var wrapperOpen = "SlideInMenu-module--wrapperOpen--2rYOy";
export var container = "SlideInMenu-module--container--3C-VW";